<template>
  <div>
    <el-dialog v-model="form.dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="true" title="微信小程序 (体验版)" width="400px" center>
      <el-row justify="center">
        <el-text style="font-size: 16px;">魔小期</el-text>
      </el-row>
      <el-row justify="center">
        <el-image style="width: 200px;" :src="require('@/assets/tiyan.jpg')" :fit="fit" />
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from "vue";
import { useRouter, useRoute } from 'vue-router'
import { http, httpNoLoading } from '../util/http'
import { ElMessage } from 'element-plus'
export default {
  props: {
    visible: {
      type: String,
      default: false
    }
  },
  setup(props) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const route = useRoute()
    const form = reactive({
      dialogFormVisible: props.visible,
    })

    // 页面传来的事件处理
    vueEvent.on('wxMiniDialogVisible', (flag) => {
      form.dialogFormVisible = flag
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {

    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('wxMiniDialogVisible', () => { })
    })

    return {
      form,
    }
  }
}
</script>
<style lang="scss" scoped></style>
